import { Music } from 'lucide-react'
import { useAuth } from '@/context/AuthContext'
import { Button } from '@/components/ui/button'

export default function NoOrgsPage() {
  const { signOut } = useAuth()
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="max-w-sm w-full text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[color:var(--primary-soft)] text-primary mb-4">
          <Music className="w-6 h-6" strokeWidth={1.75} />
        </div>
        <h1 className="text-lg font-semibold text-foreground mb-1">No organization yet</h1>
        <p className="text-sm text-muted-foreground mb-6">
          You aren't part of any organization. Contact your admin to get added to one.
        </p>
        <Button variant="outline" onClick={signOut}>Sign out</Button>
      </div>
    </div>
  )
}
